import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom"; // Import the useNavigate hook
import PageContainer from "../../components/PageContainer";
import MainContent from "../../components/MainContent";
import PageTitle from "../../components/Common/PageTitle/PageTitle";
import ActionDropdownItem from "../../components/Common/PageTitle/ActionDropdownItem";
import ActivityLoader from "../../components/Common/ActivityLoader";
import NoDataPage from "../NoDataPage";
import functions from "../../util/functions";
import Pagination from "../../components/Common/Pagination";
import { useTheme } from "../../DataStore/ThemeContext";
import AlertDateSelector from "../../components/Report/AlertDateSelector";
import Notification from "../../components/Common/Notification";
import printContent from "../../util/araknerdlib";
import StudentWalletnfo from "../../components/SchoolFees/Student/StudentWalletnfo";
import WalletProfileMetric from "../../components/SchoolFees/Student/WalletProfileMetric";
import { useSchWalletProfile } from "../../DataStore/SchWalletProfileContext";
import WalletStatement from "../../components/SchoolFees/Student/WalletStatement";
import NewWalletTransactionModal from "../../components/SchoolFees/Student/NewWalletTransactionModal";

const StudentWalletPage = () => {
  const { 
    profileInfo, 
    studentId, 
    walletStats, 
    walletStatement,  
    loadProfile, 
    metaData, 
    setCurrentPage, 
    getWalletStatement,
    dispatch
  } = useSchWalletProfile();
  const {openSettings} = useTheme();
  const navigate = useNavigate();
  const [showDateAlert, setShowDateAlert] = useState(false);
  const [info, setInfo] = useState(null);
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [transactionType, setTransactionType] = useState('deposit'); // 'deposit' or 'withdrawal'
  const statementRef = useRef(); // Ref to enclose statement content for printing

  useEffect(()=>{
    // Redirect if no studentId
    if (!studentId) {
        navigate('/'); // Navigate to the previous page
    }
    setInfo(null);
    loadProfile();
  }, [studentId])

  if (profileInfo === "404") {
    return <NoDataPage />;
  }

  const PageActions = () => (
    <>
      <ActionDropdownItem iconClass="fa fa-circle-plus" label="Deposit Money" onClick={()=>handleTransaction('deposit')}/>
      <ActionDropdownItem iconClass="fa fa-circle-minus" label="Withdraw Money" onClick={()=>handleTransaction('withdrawal')} className="text-danger"/>
      <ActionDropdownItem iconClass="fa fa-print" label="Print Statement" onClick={()=>printContent(statementRef, "Student Wallet Statement")}/>
      <ActionDropdownItem iconClass="fa fa-refresh" label="Refresh" onClick={loadProfile} />
    </>
  );



  const handleStatementDate = (range) =>{
    dispatch({ type: 'openingDate', payload: range.opening_date });
    dispatch({ type: 'closingDate', payload: range.closing_date });
    getWalletStatement(true, range);
  }

  const handleTransaction = (type) =>{
    setTransactionType(type);
    setShowTransactionModal(true);
  }
 
  return (
    <>
    <PageContainer>
      <MainContent>
        <PageTitle
          title="Student Wallet"
          description="View and manage student's pocket money balance."
          iconClass="fa fa-wallet"
          PageActions={PageActions}
          sticky={true}
          Pagination={metaData ? <Pagination
            metaData={metaData}
            onPageChange={(page) => setCurrentPage(page)}
            loadMore={true}
    /> : <></>}
        />
        {info}
       <div className="row">
            <div className="col-12 mb-3">
              {functions.isObject(profileInfo) && <StudentWalletnfo profileInfo={profileInfo} />}
              {!profileInfo && <ActivityLoader />}
            </div>
        <div className="col-12 mb-3"> <WalletProfileMetric deposits={walletStats?.total_deposited} withdraws={walletStats?.total_withdrawn} balance={walletStats?.balance} last_transaction={walletStats?.last_transaction} /> </div>
          {/* Statement: full width, maximum height */}
          <div className="col-12">

             <div className="card rac-card mt-4">
                  {/* Header */}
                  <div className="rac-head d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center" style={{ gap: 12 }}>
                      <div className="rac-headIcon">
                        <i className="fa fa-book-open" />
                      </div>
                      <div>
                        <h6 className="rac-title">Wallet statement</h6>
                        <div className="rac-sub">Student statement of accounts</div>
                      </div>
                    </div>
            
                  </div>


           

               <div className="yx-card-body yx-statementBody">
                {functions.isObject(walletStatement) && (
                  <WalletStatement
                    statement={walletStatement}
                    student={profileInfo}
                    customRef={statementRef}
                  />
                )}

                {walletStatement === "404" && (
                  <p className="yx-muted text-center mb-0">No transactions found</p>
                )}

                {!walletStatement && <ActivityLoader />}
              </div> 
            </div>
          </div>
        </div>


        
      </MainContent>
    </PageContainer>
    <AlertDateSelector
            show={showDateAlert}
            onClose={() => setShowDateAlert(false)}
            onConfirm={handleStatementDate}
        />
     
     <NewWalletTransactionModal
        show={showTransactionModal}
        onClose={() => setShowTransactionModal(false)}
        studentId={studentId}
        student={profileInfo}
        transactionType={transactionType}
        onRefresh={loadProfile}
     />

    </>
  );
};

export default StudentWalletPage;
